import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M14.884 13.302a2.256 2.256 0 0 1 3.383 1.954v.46a3.142 3.142 0 0 1-.967 2.188l.644.13c1.528.36 2.578 1.134 2.579 2.032v3.29a.645.645 0 0 1-.645.644h-7.733a.645.645 0 0 1-.645-.645v-3.289c0-.898 1.05-1.672 2.578-2.033.012-.002.426-.094.645-.129a3.119 3.119 0 0 1-.967-2.187v-.461c0-.806.43-1.551 1.128-1.954Z"></path><path d="M17 7a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2h2Z"></path><path fill-rule="evenodd" d="M22 4a2 2 0 0 1 2 2v20l-.01.204A2 2 0 0 1 22 28H10l-.204-.01a2 2 0 0 1-1.785-1.786L8 26V6a2 2 0 0 1 1.796-1.99L10 4h12ZM10 26h12V6H10v20Z" clip-rule="evenodd"></path></g>';
export var IdBadgeOutlineSVG = function IdBadgeOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
IdBadgeOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(IdBadgeOutlineSVG);